module.exports = __webpack_public_path__ + "img/app.9ea3ea73.png";